import { TreeInstance } from '@headless-tree/core';
import { createContext } from 'react';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';

export type ContextProps = {
  tree?: TreeInstance<InternalTreeItem>;
  setTree: React.Dispatch<
    React.SetStateAction<TreeInstance<InternalTreeItem> | undefined>
  >;
};

export const Context = createContext<ContextProps>({
  tree: undefined,
  setTree: () => {},
});
